import { useRef } from 'react';
import { useImmer } from 'use-immer';
export function useMethodsExtension(reducers, setState) {
    const methodsRef = useRef(undefined);
    if (!methodsRef.current) {
        methodsRef.current = Object.keys(reducers).reduce((methods, key) => {
            const fn = reducers[key];
            const bound = (...args) => setState(s => fn(s, ...args));
            Object.assign(methods, { [key]: bound });
            return methods;
        }, {});
    }
    return methodsRef.current;
}
export function useMethods(reducers, initialState) {
    const [state, setState] = useImmer(initialState);
    const boundMethods = useMethodsExtension(reducers, setState);
    return [state, boundMethods, setState];
}
//# sourceMappingURL=immer.js.map